//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import {qrcanvas} from "qrcanvas"
import html2canvas from 'html2canvas'
import { setTimeout } from 'timers';
export default {
    data(){
        return {
            data:'',
            picData:'',
            numRandom:this.$route.query.random
        }
    },
    methods:{
    //    getImg(){
    //        let _this=this;
    //        html2canvas(this.$refs.imageWrapper,{
    //            backgroundColor: null
    //        }).then((canvas)=>{
    //             let dataURL = canvas.toDataURL("image/png");
    //             _this.data = dataURL;
    //        })
    //        this.data = "0"
    //        console.log(this.data)
    //        console.log("----------------")
    //        console.log(this.data.length)
    //    },
       getQrcode(){
            let that=this;
            let qrCodeImg= document.getElementById('qrcodeimg');
            let sessionId= this.$store.state.userInfo.sessionId;
            this.$store.state.userInfo.sessionId='';
            this.$store.state.userInfo.sessionId='haozhongyi';
            this.$doRequest('/api/photoprescribing/qrcodeinfo',{ "parameters":this.numRandom},res=>{
                that.picData=res.parameters;
                // this.getImg()
                that.$store.state.userInfo.sessionId=sessionId;
            })
       }
    },
    created(){
        document.title="支付步骤";
    },
    mounted(){
        this.getQrcode();

    }
}



// WEBPACK FOOTER //
// ./src/views/paymentSteps/index.vue